import React from 'react'
import styles from './styles.module.scss'
import PictureList from './PictureList'
import LinkList from './LinkList'
import DocumentList from './DocumentList'

const MediaTabContent = ({ scope, id, type, title, noDatatitle, handleDelete, deleteFileLoading, isStatic }) => {
  return (
    <div className={styles.filesWrapper}>
      <div className={styles.header}>
        <h2 className={styles.headerTitle}>{title}</h2>
      </div>
      {scope === 'pictures_media' && (
        <PictureList
          handleDelete={handleDelete}
          id={id}
          type={type}
          noDatatitle={noDatatitle}
          deleteFileLoading={deleteFileLoading}
          isStatic={isStatic}
          parentElementId='mediaWrapper'
        />
      )}
      {scope === 'links_media' && (
        <LinkList
          handleDelete={handleDelete}
          id={id}
          type={type}
          noDatatitle={noDatatitle}
          deleteFileLoading={deleteFileLoading}
          isStatic={isStatic}
        />
      )}
      {scope === 'documents_media' && (
        <DocumentList
          handleDelete={handleDelete}
          id={id}
          type={type}
          noDatatitle={noDatatitle}
          deleteFileLoading={deleteFileLoading}
          isStatic={isStatic}
        />
      )}
    </div>
  )
}

export default MediaTabContent
